import React from 'react';
const awards = ['The Knot Best of Weddings — Hall of Fame', 'WeddingWire Couples’ Choice 2018–2024', 'Green America Certified'];
export function TestimonialBand() {
  return <section className="mt-20 bg-sand px-6 py-14" data-id="element-52" data-mp="12gr636vrgwvo">
      <figure className="mx-auto max-w-3xl text-center" data-id="element-53" data-mp="12ffyevz734za">
        <blockquote data-id="element-54" data-mp="yfxea2f76xxi">
          <p className="mx-auto max-w-2xl font-body text-[15px] leading-relaxed text-ink/80" data-id="element-55" data-mp="yemdmbh1u6am">
            We had the most incredible experience working with the team at Twenty Mile House! They
            provide nearly all the vendors for our wedding weekend (photography, coordinator,
            catering, cake/dessert, DJ, florist, bartenders/service staff, etc.) which made planning
            streamlined and far less stressful. We loved the option of having the rehearsal dinner
            and lodging on site the night prior which allowed us to fully settle into the weekend.
            From the historic buildings, sweeping trees, natural creek, and train tracks nearby,
            guests could not stop commenting on how gorgeous it all was. We are so grateful we
            found and opted to go with TMH for our wedding!!!
          </p>
        </blockquote>
        <figcaption className="mt-6 font-sans text-[9px] font-medium uppercase tracking-[0.35em] text-ink/60" data-id="element-56" data-mp="1eflkk6hfjvpc">
          Heather L. — Bride
        </figcaption>
      </figure>
      <ul className="mx-auto mt-10 flex max-w-4xl flex-col items-center justify-center gap-3 md:flex-row md:gap-0" data-id="element-57" data-mp="2669lpij3t130">
        {awards.map((award, i) => <li key={award} className={`px-8 text-center font-sans text-[9px] font-medium uppercase tracking-[0.25em] text-ink/70 ${i > 0 ? 'md:border-l md:border-ink/25' : ''}`} data-id="element-58" data-mp="2b41gckb4v1aw" data-mpi={i}>
            {award}
          </li>)}
      </ul>
    </section>;
}